import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagTransfer = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={18} fill="none" {...props}>
    <path
      d="M6.25 2.624l-4.875 4.5h13.5M13.75 15.374l4.875-4.5h-13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagTransfer;
